import { faHandHoldingUsd } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Box, Card, CardHeader, Typography, useTheme } from "@material-ui/core";
import axios from "axios";
import React, { useContext, useEffect, useState } from "react";
import { UsersData } from "src/ContextAPI";
import Notify from "src/notification/Notify";
import IsMountedRef from "src/utils/IsMountedRef";

const GrandCardReceivable = () => {
  const { users } = useContext(UsersData);
  const mounted = IsMountedRef();
  const [grandReceivable, setGrandRecievable] = useState(0);
  const theme = useTheme();

  const getAllReceivable = React.useCallback(async () => {
    let response = await axios.get("accounting/grand/recievable-totalamount", {
      params: {
        management_id: users.management_id,
      },
    });

    if (mounted.current) {
      if (response.data.length > 0) {
        calculateTotal(response.data);
      }
    }
  }, [mounted, users]);

  const calculateTotal = (data) => {
    let xx = 0;

    for (let i = 0; i < data.length; i++) {
      if (data[i].length > 0) {
        var data2 = data[i];
        for (let j = 0; j < data2.length; j++) {
          xx += parseFloat(data2[j].bill_amount) * 1;
        }
      }
    }

    setGrandRecievable(xx);
  };

  useEffect(() => {
    getAllReceivable();
  }, [getAllReceivable]);

  return (
    <Card elevation={5}>
      <CardHeader
        avatar={
          <FontAwesomeIcon
            icon={faHandHoldingUsd}
            size={"5x"}
            style={{ color: `${theme.palette.primary.main}` }}
          />
        }
        title={
          <Typography variant="h4" color="textSecondary" noWrap>
            Receivables
          </Typography>
        }
        // subheader={
        //   <Typography variant="h5">
        //     <strong> &#8369; {Notify.convertToNumber(grandReceivable)} </strong>
        //   </Typography>
        // }
      />

      <Box mb={2}>
        <Typography variant="h4" align="center">
          <strong> &#8369; {Notify.convertToNumber(grandReceivable)} </strong>
        </Typography>
      </Box>
    </Card>
  );
};

export default GrandCardReceivable;
